interface CsvExportResponse {
    custom_http_response: {
        body: string
        headers: Record<string, string>
        statusCode: number
        isBase64Encoded: boolean
    }
}

/**
 *
 */
const downloadCsvFile = ({ custom_http_response: response }: CsvExportResponse): void => {
    if (!response || response.statusCode !== 200 || typeof response.body !== 'string') {
        throw new Error('Error downloading CSV')
    }

    const disposition = Object.entries(response.headers || {})
        .find(([name]) => name.toLowerCase() === 'content-disposition')
    const filenameMatch = disposition?.[1].match(/filename\s*=\s*(?:"([^"]+)"|([^;]+))/i)
    const filename = filenameMatch?.[1] || filenameMatch?.[2]?.trim() || 'lr-calls.csv'
    const content = response.isBase64Encoded
        ? Uint8Array.from(atob(response.body), (character) => character.charCodeAt(0))
        : response.body
    const blob = new Blob([content], { type: 'text/csv;charset=utf-8' })
    const url = window.URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    link.download = filename
    document.body.appendChild(link)
    try {
        link.click()
    } finally {
        link.remove()
        setTimeout(() => window.URL.revokeObjectURL(url), 1000)
    }
}

export default downloadCsvFile
